import { ref } from "vue";

export const showSelectedModalProductHappy = ref(false)